import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'roo-ui/components';
import styled from '@emotion/styled';
import Header from 'components/Header';
import Footer from 'components/Footer';
import SiteMessage from 'components/SiteMessage';
import Routes from 'components/Routes';
import UnintendedDateChangeDialog from 'components/UnintendedDateChangeDialog';
import { useDataLayerPageVariables } from 'lib/datalayer/hooks/useDataLayerPageVariables';
import AppVersionFetcher from 'components/AppVersionFetcher';

// Firefox doesn't like printing flexboxes, so display the main app as a block for printing
const AppWrapper = styled(Flex)`
  flex-direction: column;

  @media print {
    display: block;
  }
`;

// Drop useDataLayerPageVariables down into a sub component so the state isn't
// part of the map AppWrapper which causes a full app render twice
// whenever the data layer variables change
const DataLayerPageVariables = () => {
  useDataLayerPageVariables();
  return null;
};

const App = ({ children }) => {
  return (
    <AppWrapper role="main">
      <Box flex="1 0 auto" width="100%" bg="greys.porcelain">
        <SiteMessage />
        <Header />
        <Box id="content" minHeight="100vh">
          <Routes />
        </Box>
      </Box>
      <Footer />
      {children}
      <DataLayerPageVariables />
      <UnintendedDateChangeDialog />
      <AppVersionFetcher />
    </AppWrapper>
  );
};

App.propTypes = {
  children: PropTypes.node.isRequired,
};

export default App;
